/**
 * Redirects from old cart routes to the unified `/properties` grid.
 * Preserves any "filter" intent via querystring.
 */

import { CircularProgress, Container } from '@mui/material';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { useGetMyBuyerContractsQuery } from '@/apis/extended/contractApi';

export const RedirectMainToProperties = () => (
  <Navigate to="/properties" replace />
);
export const RedirectQualifiedToProperties = () => (
  <Navigate to="/properties" replace />
);
export const RedirectContractToProperties = () => (
  <Navigate to="/properties" replace />
);
export const RedirectRefinanceToProperties = () => (
  <Navigate to="/properties?filter=refinance" replace />
);
export const RedirectRefinanceIntakeToAddProperty = () => (
  <Navigate to="/properties/add?isRefinance=1" replace />
);

/** /contract/:productId → /properties/:productId/stage/5 */
export const RedirectContractDetailToDealRoom = () => {
  const { productId } = useParams<{ productId: string }>();
  if (!productId) return <Navigate to="/properties" replace />;
  return <Navigate to={`/properties/${productId}/stage/5`} replace />;
};

/** /buyer/property-dashboard/:contractId → /properties/:productId/stage/7 */
export const RedirectBuyerPropertyDashboardToDealRoom = () => {
  const { contractId } = useParams<{ contractId: string }>();
  const [search] = useSearchParams();
  const allowReroute = search.get('unified') !== '0';
  const { data, isLoading } = useGetMyBuyerContractsQuery(undefined, {
    skip: !contractId || !allowReroute,
  });
  if (!contractId || !allowReroute) {
    return <Navigate to="/properties" replace />;
  }
  if (isLoading) {
    return (
      <Container sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }
  const match = data?.find((c) => c._id === contractId);
  const productId = (match?.product as { _id?: string } | undefined)?._id;
  if (productId) {
    return <Navigate to={`/properties/${productId}/stage/7`} replace />;
  }
  return <Navigate to="/properties" replace />;
};
